module.exports = __webpack_public_path__ + "static/media/CarouselLeftArrow.ccd18a84.svg";